import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useConfig } from '../../DataStore/ConfigContext';
import { useStudent } from '../../DataStore/StudentContext';

// Reusable component for a dropdown item
const DropdownItem = ({ classObj, onSelect }) => {
  const location = useLocation();
  const {filterClass} = useStudent();
  const isActive = (filterClass === classObj.class_id);

  return (
    <div
      className={`dropdown-item ${filterClass === classObj.class_id ? 'active' : ''}`}
      onClick={() => onSelect(classObj)}
      style={{ cursor: 'pointer' }}
    >
      {classObj.class_name} - {classObj.level?.level || ''}
    </div>
  );
};

const ReportsLink = () => {
  const { classes, getClasses } = useConfig();
  const {getStudents } = useStudent();
  const navigate = useNavigate();

  useEffect(() => {
    getClasses();
  }, []);

  const handleClassSelect = (classObj) => {
    getStudents(true, classObj.class_id); // Refresh student list with selected class filter
    navigate("/student-list");
  };

  return (
    <li className="btn-group nav-item">
      <span className="nav-link" data-toggle="dropdown" aria-expanded="false" style={{ cursor: 'pointer' }}>
        <i className="nav-link-icon fa fa-layer-group"></i> Class Lists
        <i className="fa fa-angle-down ml-2 opacity-5"></i>
      </span>
      <div role="menu" className="rm-pointers dropdown-menu">
        <div className="scroll-area-xs-none">
          <div className="scrollbar-container">
            {Array.isArray(classes) &&
              classes.map((cls) => (
                <DropdownItem key={cls.class_id} classObj={cls} onSelect={handleClassSelect} />
              ))}
          </div>
        </div>
      </div>
    </li>
  );
};

export default ReportsLink;
